import UUID from '../UUID';
export default class {
  public constructor(
    readonly id: UUID,
    readonly order?: number | undefined,
    readonly index?: number
  ) {}
}
